export const YAMALUBE = 'yamalube';
export const WEIGHT_UNIT = {
    litre: 'lit',
    milliliter: 'ml',
};
export const SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
export const SIZE_GUIDE_BUTTON_DELAY = 2500;
